import tail from 'lodash-es/tail';

/*
  #NOTE: The modal object that you send to this model is described by the following:
  {
    component: React.Component (required),
    props: Object (required, can be empty),
    dismissable: boolean (optional; defaults to true),
  }
  -- TJC - March 03, 2020
*/

export default {
  namespace: 'modals',

  state: {
    stack: []
  },

  effects: {
  },

  reducers: {
    clearStack: (state, action) => {
      return {
        ...state,
        stack: []
      };
    },
    add: (state, {payload: modal}) => {
      return {
        ...state,
        stack: [modal].concat(state.stack)
      };
    },
    close: (state, action) => {
      return {
        ...state,
        stack: tail(state.stack)
      };
    }
  }
};
